import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../App';
import { Button } from '@/components/ui/button';
import { LayoutDashboard, Package, Sparkles, Calendar, LogOut, Menu, X, Shield, User, Receipt, Settings, Tag, Users, Building2, ChevronDown, ChevronRight } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';

export const Layout = ({ children }) => {
  const { usuario, logout } = useContext(AuthContext);
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [configuracionAbierto, setConfiguracionAbierto] = useState(
    location.pathname.startsWith('/configuracion')
  );

  useEffect(() => {
    setConfiguracionAbierto(location.pathname.startsWith('/configuracion'));
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;
  const isConfiguracionActive = location.pathname.startsWith('/configuracion');

  const MenuContent = ({ onLinkClick }) => (
    <>
      <div className="sidebar-header">
        <div className="logo" data-testid="logo">MixOptimo</div>
        <p className="text-sm text-gray-600 mt-2">{usuario?.nombre}</p>
        {usuario?.especialidad && (
          <p className="text-xs text-gray-500 mt-1">{usuario.especialidad}</p>
        )}
      </div>

      <nav className="nav-menu">
        <Link 
          to="/" 
          className={`nav-item ${isActive('/') ? 'active' : ''}`} 
          data-testid="nav-dashboard"
          onClick={onLinkClick}
        >
          <LayoutDashboard size={20} />
          Dashboard
        </Link>
        <Link 
          to="/productos" 
          className={`nav-item ${isActive('/productos') ? 'active' : ''}`} 
          data-testid="nav-productos"
          onClick={onLinkClick}
        >
          <Package size={20} />
          Productos
        </Link>
        <Link 
          to="/optimizador" 
          className={`nav-item ${isActive('/optimizador') ? 'active' : ''}`} 
          data-testid="nav-optimizador"
          onClick={onLinkClick}
        >
          <Sparkles size={20} />
          Optimizador
        </Link>
        <Link 
          to="/proyecciones" 
          className={`nav-item ${isActive('/proyecciones') ? 'active' : ''}`} 
          data-testid="nav-proyecciones"
          onClick={onLinkClick}
        >
          <Calendar size={20} />
          Proyecciones
        </Link>
        <Link 
          to="/facturas" 
          className={`nav-item ${isActive('/facturas') ? 'active' : ''}`} 
          data-testid="nav-facturas"
          onClick={onLinkClick}
        >
          <Receipt size={20} />
          Facturas
        </Link>
        
        {/* Menú Configuración */}
        <div className="nav-section">
          <button
            className={`nav-item ${isConfiguracionActive ? 'active' : ''}`}
            onClick={() => setConfiguracionAbierto(!configuracionAbierto)}
            style={{ width: '100%', justifyContent: 'space-between' }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Settings size={20} />
              Configuración
            </div>
            {configuracionAbierto ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
          </button>
          {configuracionAbierto && (
            <div className="nav-submenu">
              <Link 
                to="/configuracion/tipologias" 
                className={`nav-subitem ${isActive('/configuracion/tipologias') ? 'active' : ''}`} 
                onClick={onLinkClick}
              >
                <Tag size={16} />
                Tipologías Facturas
              </Link>
              <Link 
                to="/configuracion/clientes" 
                className={`nav-subitem ${isActive('/configuracion/clientes') ? 'active' : ''}`} 
                onClick={onLinkClick}
              >
                <Users size={16} />
                Clientes
              </Link>
              <Link 
                to="/configuracion/proveedores" 
                className={`nav-subitem ${isActive('/configuracion/proveedores') ? 'active' : ''}`} 
                onClick={onLinkClick}
              >
                <Building2 size={16} />
                Proveedores
              </Link>
            </div>
          )}
        </div>

        {usuario?.rol === 'admin' && (
          <Link 
            to="/administracion" 
            className={`nav-item ${isActive('/administracion') ? 'active' : ''}`} 
            data-testid="nav-administracion"
            onClick={onLinkClick}
          >
            <Shield size={20} />
            Administración
          </Link>
        )}
        <Link 
          to="/mi-cuenta" 
          className={`nav-item ${isActive('/mi-cuenta') ? 'active' : ''}`} 
          data-testid="nav-mi-cuenta"
          onClick={onLinkClick}
        >
          <User size={20} />
          Mi Cuenta
        </Link>
      </nav>

      <div className="sidebar-footer">
        <Button variant="outline" className="w-full" onClick={logout} data-testid="btn-logout">
          <LogOut size={18} /> Cerrar Sesión
        </Button>
      </div>
    </>
  );

  return (
    <div className="app-container">
      {/* Botón hamburguesa para móviles */}
      <div className="mobile-menu-button">
        <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
          <SheetTrigger asChild>
            <Button variant="ghost" size="icon" className="mobile-menu-trigger" data-testid="mobile-menu-button">
              <Menu size={24} />
            </Button>
          </SheetTrigger>
          <SheetContent side="left" className="mobile-sidebar">
            <MenuContent onLinkClick={() => setMobileMenuOpen(false)} />
          </SheetContent>
        </Sheet>
      </div>

      {/* Sidebar para desktop */}
      <div className="sidebar desktop-sidebar">
        <MenuContent />
      </div>

      <div className="main-content">
        {children}
      </div>
    </div>
  );
};

export default Layout;
